// extracted by mini-css-extract-plugin
export default {"label":"TextField_label__2GdTK"};